// extracted by mini-css-extract-plugin
module.exports = {"item":"SavedPlacesList_item___crrB","itemDragging":"SavedPlacesList_itemDragging__xx5jw","symbol":"SavedPlacesList_symbol__1oLub"};